import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class LogoutDetectionService {
  
  private checkInterval: any;
  private protectedRoutes = ['/user-profile', '/cart', '/orders', '/wishlist', '/order-confirmation'];

  constructor(
    private authService: AuthService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  initializeLogoutDetection(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    // Listen for storage changes (logout from other tabs)
    window.addEventListener('storage', (event) => {
      if (event.key === 'userData1' || event.key === 'userCode' || event.key === 'eol_user_code') {
        // Check if user data was removed (logout)
        if (!event.newValue) {
          setTimeout(() => {
            this.handleLogout();
          }, 100);
        }
      }
    });

    // Periodic check for logout state (every 10 seconds)
    this.checkInterval = setInterval(() => {
      this.checkLogoutState();
    }, 10000);
  }

  checkLogoutState(): void {
    const userData = localStorage.getItem('userData1');
    const userCode = localStorage.getItem('userCode');
    const eolUserCode = localStorage.getItem('eol_user_code');
    
    // If no user data exists, user is logged out
    if (!userData && !userCode && !eolUserCode) {
      this.handleLogout();
    }
  }

  private handleLogout(): void {
    // Update authentication state
    this.authService.setLoggedInState(false, null);
    
    // Check if current route requires authentication
    const currentRoute = this.router.url;
    const isProtectedRoute = this.protectedRoutes.some(route => currentRoute.includes(route));
    
    if (isProtectedRoute) {
      // Navigate to home first
      this.router.navigate(['/home']);
      
      // Then refresh the page after a short delay
      setTimeout(() => {
        if (typeof window !== 'undefined') {
          window.location.reload();
        }
      }, 100);
    }
  }

  logoutWithRefresh(): void {
    // Clear all user data
    localStorage.removeItem('userData1');
    localStorage.removeItem('userData');
    localStorage.removeItem('useractive');
    localStorage.removeItem('userCode');
    localStorage.removeItem('eol_user_code');
    localStorage.removeItem('eol_ref_token');
    localStorage.removeItem('eol_access_token');
    localStorage.removeItem('registrationPhoneNumber');
    localStorage.removeItem('registrationOtp');
    
    // Update authentication state
    this.authService.setLoggedInState(false, null);
    
    // Navigate to home
    this.router.navigate(['/home']);
    
    // Refresh the page
    setTimeout(() => {
      if (typeof window !== 'undefined') {
        window.location.reload();
      }
    }, 100);
  }

  destroy(): void {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
  }
} 